/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * File: CurrencyInput.tsx
 * Author: Austin Robinson
 * Date Created: 9/10/2022
 * Copyright (c) DrivingDoc 2022
 */
import { useMemo, useRef, useState } from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

type Option = {
  title: string;
  onClick: (coursePeriodId: string) => void;
};

type PropTypes = {
  options: Option[];
};

export function usePeriodContextMenu({ options }: PropTypes) {
  const [currentPeriodId, setCurrentPeriodId] = useState<string | null>(null);
  const contextMenuLocation = useRef<{
    mouseX: number;
    mouseY: number;
  } | null>(null);
  const element = useRef<any | null>(null);

  const openPeriodContextMenu = (coursePeriodId: string, event: MouseEvent, calendarElement?: any) => {
    event.preventDefault();
    contextMenuLocation.current = {
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    };
    if (calendarElement) {
      element.current = calendarElement;
    }
    setCurrentPeriodId(coursePeriodId);
  };

  const closePeriodContextMenu = () => {
    setCurrentPeriodId(null);
  };

  const PeriodContextMenu = useMemo(
    () => (
      <Menu
        open={currentPeriodId !== null}
        onClose={closePeriodContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenuLocation.current
            ? {
              top: contextMenuLocation.current.mouseY,
              left: contextMenuLocation.current.mouseX,
            }
            : undefined
        }
        disablePortal
      >
        <MenuList>
          {options.map((option) => (
            <MenuItem
              key={option.title}
              onClick={() => {
                if (currentPeriodId) {
                  closePeriodContextMenu();
                  option.onClick(currentPeriodId);
                }
              }}
            >
              {option.title}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    ),
    [currentPeriodId],
  );

  return {
    PeriodContextMenu: PeriodContextMenu,
    openPeriodContextMenu: openPeriodContextMenu,
    closeDriveContextMenu: closePeriodContextMenu,
  };
}

export default usePeriodContextMenu;
